export function publicAssetPath(assetPath) {
  const basePath = String(process.env.PUBLIC_URL || '').replace(/\/+$/, '');
  const relativePath = String(assetPath || '').replace(/^\/+/, '');
  return `${basePath}/${relativePath}`;
}
